// Link do monitor com posto (e quadros) já escolhidos, e a regra de entrada automática dos quadros do posto.
// Quem monta o link (tela da degustação) e quem lê (o monitor) usam estes nomes de parâmetro.

export const MONITOR_ROUTE = '/attendant-goal-boards/monitor';

/** Até este número de quadros no posto, o monitor adiciona todos ao escolher o posto. Acima, o usuário escolhe. */
export const AUTO_SELECT_MAX_BOARDS = 4;

/**
 * `/attendant-goal-boards/monitor?placeId=<posto>&boards=<id1,id2>[&tv=1]`: com `boards`, o monitor mostra exatamente
 * esses quadros; com `tv`, já abre no Modo TV (a tela cheia do navegador só entra se ele deixar, sem clique na página).
 */
export const monitorPath = (placeId: string, boardIds: string[] = [], options: { tv?: boolean } = {}): string => {
  const params = new URLSearchParams({ placeId });
  if (boardIds.length > 0) params.set('boards', boardIds.join(','));
  if (options.tv) params.set('tv', '1');
  return `${MONITOR_ROUTE}?${params.toString()}`;
};

// 8-4-4-4-12 hexadecimais, qualquer versão. O link vem da barra de endereço: id que não é UUID nunca vai ao backend
// (o cast do Postgres viraria 500 a cada atualização de 60 s do Modo TV).
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isUuid = (value: string): boolean => UUID.test(value);

/** `placeId` do link: o UUID do posto, ou '' (link sem posto, ou com posto inválido, é ignorado). */
export const parsePlaceId = (raw: string | null | undefined): string => {
  const id = (raw ?? '').trim();
  return isUuid(id) ? id : '';
};

/** `boards=a,b,,a` vira só os UUIDs válidos, sem vazio e sem repetido (os inválidos são ignorados). */
export const parseBoardIds = (raw: string | null | undefined): string[] =>
  [...new Set((raw ?? '').split(',').map((id) => id.trim()).filter(isUuid))];

/**
 * Quadros que entram sozinhos quando o posto é escolhido: todos os ativos do posto no dia, se forem de 1 a 4.
 * `null` = não mexe na seleção (nenhum quadro, ou mais de 4: o usuário escolhe em "Adicionar Quadro").
 * Quadro desativado não conta nem entra.
 */
export const autoSelectBoardIds = (boards: { id: string; isDisabled?: boolean }[] | null | undefined): string[] | null => {
  const ids = (boards ?? []).filter((b) => !b.isDisabled).map((b) => b.id);
  return ids.length > 0 && ids.length <= AUTO_SELECT_MAX_BOARDS ? ids : null;
};
